import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-6a23ed7e"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "aboutBg"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Header = _resolveComponent("Header");

  var _component_ProductCenter = _resolveComponent("ProductCenter");

  var _component_AboutUs = _resolveComponent("AboutUs");

  var _component_DevelopmentHistory = _resolveComponent("DevelopmentHistory");

  var _component_NewsTrands = _resolveComponent("NewsTrands");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Header), _createVNode(_component_ProductCenter), _createElementVNode("div", _hoisted_1, [_createVNode(_component_AboutUs), _createVNode(_component_DevelopmentHistory)]), _createVNode(_component_NewsTrands)], 64);
}